export function TableSearch({
  searchValue,
  setSearchValue,
}: {
  searchValue: string;
  setSearchValue: (value: string) => void;
}) {
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    // setSearchValue((e.target as HTMLInputElement).value);
  }

  return (
    <form
      className="flex gap-x-2 max-w-[400px] flex-col"
      onSubmit={handleSubmit}
    >
      <label htmlFor="query" className="text-sm font-bold text-gray-700 mb-1">
        Search
      </label>
      <input
        type="text"
        id="query"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 dark:focus:ring-indigo-500 sm:text-sm sm:leading-6 bg-white dark:bg-gray-800"
      />
    </form>
  );
}
